<template>
  <div>
    <v-row class="mt-2" style="margin-left:30%">
      <v-col cols="3"
        ><v-autocomplete
          v-if="selectedEventPresent"
          class="checkScroller"
          :items="eventList"
          prepend-inner-icon="search"
          return-object
          hide-details
          item-text="Name"
          label="Search Event"
          v-model="selectedEvent"
          dense
          outlined
        >
        </v-autocomplete
      ></v-col>
      <v-col cols="3"
        ><v-autocomplete
          class="checkScroller"
          :items="items"
          v-if="selectedSessionPresent"
          prepend-inner-icon="search"
          :disabled="contentLoadedAuto"
          :loading="contentLoadedAuto"
          return-object
          hide-details
          :item-text="createdSessionName"
          v-model="selectedSession"
          clearable
          label="Search Session"
          dense
          outlined
        >
        </v-autocomplete
      ></v-col>
      <v-col cols="3"></v-col>
      <v-col cols="3">
        <v-text-field
          height="20"
          dense
          class="searchField mr-1"
          solo
          v-model="search"
          hide-details
          prepend-inner-icon="search"
          label="Search User"
          clearable
        ></v-text-field
      ></v-col>
    </v-row>
    <v-row style="margin-left:30%">
      <v-data-table
        style="width:100%"
        :loading="tableLoader"
        :search="search"
        :headers="headers"
        :items-per-page="5"
        :items="tableData"
        item-key="name"
        class="elevation-1"
      ></v-data-table>
    </v-row>
    <v-navigation-drawer permanent width="30%" absolute>
      <v-list>
        <v-list-item @click="getUpcomingSessions()" style="cursor:pointer">
          <v-list-item-title>Upcoming Sessions</v-list-item-title>
        </v-list-item>
        <v-list-item @click="getPreSessions" style="cursor:pointer">
          <v-list-item-title>Previous Sessions</v-list-item-title>
        </v-list-item>
        <!-- 
        <v-list-group>
          <template v-slot:activator>
            <v-list-item-title>Reports</v-list-item-title>
          </template>

          <v-list-item v-for="(val, i) in admins" :key="i" link>
            <v-list-item-title v-text="val.name"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item>
          <v-list-item-title>My EduLife</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>Certificate Template</v-list-item-title>
        </v-list-item> -->
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import apiHandler from "@/handler/edu_handler";
export default {
  data() {
    return {
      tableLoader: false,
      search: "",
      selectedSessionPresent: true,
      selectedEventPresent: true,
      selectedSession: "",
      selectedEvent: "",
      admins: [
        { name: "Progress Report By Course" },
        { name: "Progress Report By Student" },
        { name: "Assignment Report By Course" },
        { name: "Assignment Report By Student" }
      ],
      tableData: [],
      headers: [],
      eventList: []
    };
  },
  methods: {
    getPreSessions() {
      this.tableLoader = true;
      apiHandler
        .getPreSessions({ time: 24 * 30 })
        .then(res => {
          console.log(res.data);
          if (res.data.length > 0) {
            this.selectedSessionPresent = false;
            this.selectedEventPresent = false;
            this.headers = [];
            this.tableData = [];
            let keys = Object.keys(res.data[0]);
            keys.forEach(key => {
              this.headers.push({ text: key, value: key, filterable: true });
            });
            this.tableData = res.data;
          }
          this.tableLoader = false;
        })
        .catch(e => {
          this.tableLoader = false;
          console.log(e);
        });
    },
    getUpcomingSessions() {
      this.tableLoader = true;
      apiHandler
        .getPostSessions({ time: 24 * 30 })
        .then(res => {
          console.log(res.data);
          if (res.data.length > 0) {
            this.selectedSessionPresent = false;
            this.selectedEventPresent = false;
            this.headers = [];
            this.tableData = [];
            let keys = Object.keys(res.data[0]);
            keys.forEach(key => {
              this.headers.push({ text: key, value: key, filterable: true });
            });
            this.tableData = res.data;
          }
          this.tableLoader = false;
        })
        .catch(e => {
          this.tableLoader = false;
          console.log(e);
        });
    },
    getEventDetails() {
      this.isLoading = true;
      let userObject = {
        instanceId: "OA_UAT",
        clientId: this.$store.state.client[0].id,
        attendeeId: this.$store.state.user[0].id
      };
      apiHandler
        .getCoursesByEvents(userObject)
        .then(result => {
          let res = result.data.data;
          res.forEach(element => {
            if (element.IsPublished) {
              this.eventList.push(element);
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style></style>
